export default __webpack_public_path__ + "b4b8b75a28f587432243b1998b5058d2.jpg";